import request from './request'

// Generate a unique event id. Shared between the CAPI event and the client pixel
// event so Meta can deduplicate them, and used to make server-side retries idempotent.
export const genEventId = (): string => {
    try {
        if (typeof crypto !== 'undefined' && (crypto as any).randomUUID) {
            return (crypto as any).randomUUID();
        }
    } catch (e) { /* noop */ }
    return 'e_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
}

// Read _fbc / _fbp cookies and the fbclid query param (was duplicated in every helper).
const getFbCookies = () => {
    let fbc: any = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    fbc = fbc ? fbc.split('=')[1] : '';
    let fbp: any = document.cookie.split('; ').find(row => row.startsWith('_fbp='));
    fbp = fbp ? fbp.split('=')[1] : '';
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid !== null) { fbc = fbclid; }
    return { fbc, fbp };
}

const sendEvent = (payload: any) => {
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })
}

export const productView = (product, article, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'ViewContent',
        event_source_url: window.location.href,
        content_ids: [article.sku],
        content_type: 'product',
        content_name: article.name ? product.name + ' - ' + article.name : product.name,
        fbc: fbc,
        fbp: fbp
    })
}

export const addToWishlistFB = (product, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'AddToWishlist',
        event_source_url: window.location.href,
        content_ids: [product.id],
        content_type: 'product_group',
        content_name: product.name,
        fbc: fbc,
        fbp: fbp
    })
}

export const addToCartFB = (item, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    const numItems = item.quantity;
    const value = item.price;
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'AddToCart',
        event_source_url: window.location.href,
        content_ids: [item.id],
        content_type: 'product',
        contents: [item],
        num_items: numItems,
        value: value,
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    })
}

export const searchView = (search, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'Search',
        event_source_url: window.location.href,
        search_string: search,
        fbc: fbc,
        fbp: fbp
    })
}

export const InitiateCheckoutFB = (items, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    const value = items.reduce((acc, item) => acc + parseFloat(item.price) * parseInt(item.quantity), 0);
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'InitiateCheckout',
        event_source_url: window.location.href,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        num_items: numItems,
        value: value,
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    })
}

export const AddPaymentInfoFB = (order, items, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'AddPaymentInfo',
        event_source_url: window.location.href,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        order_id: order.id,
        num_items: numItems,
        value: parseFloat(order.total_ttc),
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    })
}

export const PurchaseFB = (order, items, eventId = '') => {
    const { fbc, fbp } = getFbCookies();
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    return sendEvent({
        event_id: eventId || genEventId(),
        event_name: 'Purchase',
        event_source_url: window.location.href,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        order_id: order.id,
        num_items: numItems,
        value: parseFloat(order.total_ttc),
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    })
}
